import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import Divider from '../Divider/Divider'
import Box from './Box'
import { useLocation } from 'react-router-dom'
import { debug } from 'js/utils/debug'
import { facebookLoginStateItemKey } from '../Login/Login'

type Props = {
  onLoginClick: () => void
  onSignUpClick: () => void
}

export default function SignUpOrLogin({ onLoginClick, onSignUpClick }: Props) {
  const location = useLocation()

  // If a user is being logged in with a third party login redirect solution
  // we know if the user wants to login or signup
  useEffect(() => {
    const hashParams = new URLSearchParams(location.hash.slice(1))
    const token = hashParams.get('access_token')
    const state = hashParams.get('state') || ''
    const redirectAction = state.match(
      new RegExp(`(${facebookLoginStateItemKey}|signup)`),
    )?.[1]

    debug(`redirectAction: ${redirectAction}`)
    debug(JSON.stringify({ token, state }, null, 2))

    switch (redirectAction) {
      case facebookLoginStateItemKey:
        onLoginClick()
        break
      case 'signup':
        onSignUpClick()
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <div className="o-width-limiter">
      <Box visibleBox={false}>
        <div>
          <button
            data-uid="sign_up_button"
            className="c-button c-button--choice w-full"
            onClick={onSignUpClick}
          >
            <span>
              <span>
                <span className="c-button--choice-small-text">
                  <FormattedMessage {...messages.noAccount} />
                </span>
                <FormattedMessage {...messages.signUp} />
              </span>
            </span>
          </button>
          <div className="my-32">
            <Divider light={true} />
          </div>
          <button
            data-uid="login_button"
            className="c-button c-button--choice w-full"
            onClick={onLoginClick}
          >
            <span>
              <span className="c-button--choice-small-text">
                <FormattedMessage {...messages.alreadyHave} />
              </span>
              <FormattedMessage {...messages.logIn} />
            </span>
          </button>
        </div>
      </Box>
    </div>
  )
}
